"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFixed3NoTrailing0s = exports.toFixed3 = exports.toFixed2NoTrailing0s = exports.toFixed2 = exports.populate3DCalculatorSchema = exports.convert3DCalculatorSchemaTo2D = exports.convert2DCalculatorSchemaTo3D = void 0;

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// calculator helpers
var mapFund = function mapFund(fund) {
  return {
    FundId: fund.FundId,
    FundName: fund.FundName,
    FundSubCategoryId: fund.FundSubCategoryId,
    FundSubCategoryName: fund.FundSubCategoryName,
    Ticker: fund.Ticker,
    FeeRate: fund.FeeRate,
    MaximumAllocation: fund.MaximumAllocation,
    Message: fund.Message,
    AgeBrackets: fund.AgeBrackets
  };
};

var populate3DCalculatorSchema = function populate3DCalculatorSchema(matrixAllocations, schema3D) {
  var populated3DSchema = (0, _lodash.cloneDeep)(schema3D);
  populated3DSchema.FundCategories.forEach(function (category, categoryIndex) {
    return category.Funds.forEach(function (fund, fundIndex) {
      return fund.AgeBrackets.forEach(function (ageBracket, bracketIndex) {
        return ageBracket.Percentage = isNaN(parseFloat(matrixAllocations[categoryIndex][fundIndex][bracketIndex])) ? 0 : parseFloat(matrixAllocations[categoryIndex][fundIndex][bracketIndex]);
      });
    });
  });
  return populated3DSchema;
};

exports.populate3DCalculatorSchema = populate3DCalculatorSchema;

var convert3DCalculatorSchemaTo2D = function convert3DCalculatorSchemaTo2D(matrixAllocations, schema3D) {
  var schema2D = {
    TemplateId: schema3D.TemplateId,
    TemplateName: schema3D.TemplateName,
    TemplateType: schema3D.TemplateType,
    AssetFeeRate: schema3D.AssetFeeRate,
    Funds: []
  };

  if (schema3D.TemplateTypeDescription) {
    schema2D.TemplateTypeDescription = schema3D.TemplateTypeDescription;
  }

  schema2D.Funds = schema3D.FundCategories.reduce(function (flattenedArr, category, categoryIndex) {
    var flattenedFunds = category.Funds.map(function (fund, fundIndex) {
      var updatedAgeBrackets = fund.AgeBrackets.map(function (ageBracket, ageBracketIndex) {
        var updatedAgeBracket = _objectSpread({}, ageBracket);

        updatedAgeBracket.Percentage = isNaN(parseFloat(matrixAllocations[categoryIndex][fundIndex][ageBracketIndex])) ? 0 : parseFloat(matrixAllocations[categoryIndex][fundIndex][ageBracketIndex]);
        return updatedAgeBracket;
      });

      var updatedFund = _objectSpread({}, fund);

      updatedFund.FundCategoryName = category.FundCategoryName;
      updatedFund.FundCategoryId = category.FundCategoryId;
      updatedFund.FundCategoryColor = category.FundCategoryColor;
      updatedFund.AgeBrackets = updatedAgeBrackets;
      return updatedFund;
    });
    return flattenedArr.concat(flattenedFunds);
  }, []);
  return schema2D;
};

exports.convert3DCalculatorSchemaTo2D = convert3DCalculatorSchemaTo2D;

var convert2DCalculatorSchemaTo3D = function convert2DCalculatorSchemaTo3D(schema2D) {
  var schema3D = {
    TemplateId: schema2D.TemplateId,
    TemplateName: schema2D.TemplateName,
    TemplateType: schema2D.TemplateType,
    AssetFeeRate: schema2D.AssetFeeRate,
    FundCategories: []
  };

  if (schema2D.TemplateTypeDescription) {
    schema3D.TemplateTypeDescription = schema2D.TemplateTypeDescription;
  }

  var previousFundCategoryId = -1;
  var currFundCategory = {};
  schema2D.Funds.forEach(function (fund) {
    if (previousFundCategoryId !== fund.FundCategoryId) {
      // initialize another fund category
      var firstFund = mapFund(fund);
      currFundCategory = {
        FundCategoryId: fund.FundCategoryId,
        FundCategoryName: fund.FundCategoryName,
        FundCategoryColor: fund.FundCategoryColor,
        Funds: [firstFund]
      };
      schema3D.FundCategories.push(currFundCategory);
      previousFundCategoryId = fund.FundCategoryId;
    } else {
      currFundCategory.Funds.push(mapFund(fund));
    }
  });
  return schema3D;
};

exports.convert2DCalculatorSchemaTo3D = convert2DCalculatorSchemaTo3D;

var toFixed2 = function toFixed2(num) {
  return (Math.round(num * 100) / 100).toFixed(2);
};

exports.toFixed2 = toFixed2;

var toFixed3 = function toFixed3(num) {
  return (Math.round(num * 1000) / 1000).toFixed(3);
};

exports.toFixed3 = toFixed3;

var toFixed2NoTrailing0s = function toFixed2NoTrailing0s(num) {
  // also remove any trailing zeros
  return parseFloat((Math.round(num * 100) / 100).toFixed(2));
};

exports.toFixed2NoTrailing0s = toFixed2NoTrailing0s;

var toFixed3NoTrailing0s = function toFixed3NoTrailing0s(num) {
  // also remove any trailing zeros
  return parseFloat((Math.round(num * 1000) / 1000).toFixed(3));
};

exports.toFixed3NoTrailing0s = toFixed3NoTrailing0s;